(function() {
  'use strict';

  function initMegaMenu() {
    const navItems = document.querySelectorAll('.nav-item.has-mega-menu');
    
    // Check if the current screen size is mobile/tablet
    const isMobile = () => window.innerWidth < 992;

    navItems.forEach(item => {
      const trigger = item.querySelector('.nav-link');
      const megaMenu = item.querySelector('.mega-menu');
      let openTimeout = null;
      let closeTimeout = null;

      if (!trigger || !megaMenu) return;

      // Set accessibility attributes
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-haspopup', 'true');
      megaMenu.setAttribute('aria-hidden', 'true');

      // Helper function to open the mega menu on desktop
      const openMenu = () => {
        clearTimeout(closeTimeout);
        if (isMobile()) return;
        
        openTimeout = setTimeout(() => {
          // Close any other open mega menus to prevent overlap
          document.querySelectorAll('.nav-item.has-mega-menu.is-active').forEach(otherItem => {
            if (otherItem !== item) {
              otherItem.classList.remove('is-active');
              otherItem.querySelector('.nav-link')?.setAttribute('aria-expanded', 'false');
              otherItem.querySelector('.mega-menu')?.setAttribute('aria-hidden', 'true');
            }
          });

          item.classList.add('is-active');
          trigger.setAttribute('aria-expanded', 'true');
          megaMenu.setAttribute('aria-hidden', 'false');
        }, 150); // 150ms debounce delay
      };

      // Helper function to close the mega menu on desktop
      const closeMenu = () => {
        clearTimeout(openTimeout);
        if (isMobile()) return;

        closeTimeout = setTimeout(() => {
          item.classList.remove('is-active');
          trigger.setAttribute('aria-expanded', 'false');
          megaMenu.setAttribute('aria-hidden', 'true');
        }, 150); // 150ms close delay
      };

      // Desktop Hover Listeners
      item.addEventListener('mouseenter', openMenu);
      item.addEventListener('mouseleave', closeMenu);

      // Desktop Keyboard Navigation / Accessibility focus
      trigger.addEventListener('focus', () => {
        if (!isMobile()) {
          openMenu();
        }
      });

      // Close Mega Menu if Escape is pressed when focused inside the menu
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          clearTimeout(openTimeout);
          item.classList.remove('is-active');
          trigger.setAttribute('aria-expanded', 'false');
          megaMenu.setAttribute('aria-hidden', 'true');
          trigger.focus();
        }
      });

      // Mobile Top-Level Level-1 Accordion Toggle
      trigger.addEventListener('click', (e) => {
        if (isMobile()) {
          e.preventDefault();
          e.stopPropagation();

          const isOpen = item.classList.contains('open');

          // Close other mobile top-level menus
          document.querySelectorAll('#navbarNav .nav-item.open').forEach(otherItem => {
            if (otherItem !== item) {
              otherItem.classList.remove('open');
            }
          });

          if (isOpen) {
            item.classList.remove('open');
          } else {
            item.classList.add('open');
          }
        }
      });
    });

    // Mobile Brand Level-2 Accordion Toggles
    const brandHeadings = document.querySelectorAll('.mega-menu-column .mega-menu-heading');
    brandHeadings.forEach(heading => {
      heading.addEventListener('click', function(e) {
        if (!isMobile()) return;

        const parentColumn = heading.closest('.mega-menu-column');
        const list = parentColumn?.querySelector('.mega-menu-list');

        if (list) {
          e.preventDefault();
          e.stopPropagation();

          const isOpen = parentColumn.classList.contains('brand-open');
          
          // Collapse sibling brand lists inside this mega menu
          const parentGrid = parentColumn.closest('.mega-menu-grid');
          if (parentGrid) {
            parentGrid.querySelectorAll('.mega-menu-column').forEach(col => {
              if (col !== parentColumn) {
                col.classList.remove('brand-open');
              }
            });
          }

          if (isOpen) {
            parentColumn.classList.remove('brand-open');
          } else {
            parentColumn.classList.add('brand-open');
          }
        }
      });
    });

    // Keyboard Arrow Navigation within Mega Menu
    navItems.forEach(item => {
      const megaMenu = item.querySelector('.mega-menu');
      if (!megaMenu) return;

      megaMenu.addEventListener('keydown', (e) => {
        const focusableElements = megaMenu.querySelectorAll('a, button');
        const activeEl = document.activeElement;
        const index = Array.prototype.indexOf.call(focusableElements, activeEl);

        if (index > -1) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            const nextEl = focusableElements[index + 1] || focusableElements[0];
            nextEl.focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const prevEl = focusableElements[index - 1] || focusableElements[focusableElements.length - 1];
            prevEl.focus();
          }
        }
      });
    });
  }

  // Support re-init for theme customizer block re-rendering in the editor
  document.addEventListener('DOMContentLoaded', initMegaMenu);
  
  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('shopify-header-section') || e.target.querySelector('#main-header')) {
      initMegaMenu();
    }
  });
})();
